import { StageController } from "../Components/StageController";
import { Scaling } from "../Utils/Scaling";
import { ContainerElement } from "../Components/Elements/Graphics/ContainerElement";
import { ImageElement } from "../Components/Elements/Graphics/ImageElement";
import { Jackpot } from "../Channels/Common/Bonuses/Jackpot";

export class GridMagnifier {
    private static Zoom: number = 2;

    private static BaseRenderTexture: PIXI.BaseRenderTexture;
    private static RenderTexture: PIXI.RenderTexture;

    private static Texture: PIXI.Texture;
    private static Sprite: PIXI.Sprite;
    private static MagnifierContainer: ContainerElement;

    private static Rectangle: PIXI.Rectangle;

    private static View: ContainerElement;

    private static Width: number;
    private static Height: number;

    private static Manager: PIXI.interaction.InteractionManager;
    private static Point: PIXI.Point;

    public static initialize(view: ContainerElement, magnifierContainer: ContainerElement): void {
        if (magnifierContainer != null) {
            //out main magnifier container
            GridMagnifier.MagnifierContainer = magnifierContainer;

            //get info about frame image, to get width and height for our magnifier
            let image = <ImageElement>magnifierContainer.childs["Frame"];
            let bounds = image.getLocalBounds();
            GridMagnifier.Width = bounds.width;
            GridMagnifier.Height = bounds.height;

            //create base render texture where we will render our stage
            GridMagnifier.BaseRenderTexture = new PIXI.BaseRenderTexture(
                StageController.Width,
                StageController.Height,
                PIXI.SCALE_MODES.LINEAR,
                1,
            );
            if (Scaling.isPortrait()) {
                GridMagnifier.BaseRenderTexture.resize(StageController.Height, StageController.Width);
            }

            //create rendertexture, where we will render stage into
            GridMagnifier.RenderTexture = new PIXI.RenderTexture(GridMagnifier.BaseRenderTexture);

            //create texture from renderTexture.baseTexture for manipulating final frame
            GridMagnifier.Texture = new PIXI.Texture(GridMagnifier.RenderTexture.baseTexture);

            //create sprite object, with our texture
            GridMagnifier.Sprite = new PIXI.Sprite(GridMagnifier.Texture);
            GridMagnifier.Sprite.scale.set(GridMagnifier.Zoom);

            //create rectangle used for framing stage
            GridMagnifier.Rectangle = new PIXI.Rectangle(0, 0, GridMagnifier.Width * 0.5, GridMagnifier.Height * 0.5);
            GridMagnifier.View = view;

            //add sprite into magnifierContainer placeholder
            let magnifierContent = <ContainerElement>magnifierContainer.childs["Content"];
            magnifierContent.addChild(GridMagnifier.Sprite);

            //set initialized visible to false and addChild to Stage
            magnifierContainer.visible = false;
            StageController.Stage.addChild(magnifierContainer);

            GridMagnifier.Point = new PIXI.Point();
            GridMagnifier.Manager = new PIXI.interaction.InteractionManager(StageController.Renderer);
        }
    }

    public static touchMoveMagnifier(x: number, y: number): void {
        if (GridMagnifier.MagnifierContainer != null && GridMagnifier.Manager != null) {
            //get map mouse x,y to canvas x,y position
            GridMagnifier.Manager.mapPositionToPoint(GridMagnifier.Point, x, y);
            let relativeX = GridMagnifier.Point.x;
            let relativeY = GridMagnifier.Point.y;

            //update rect area position
            GridMagnifier.Rectangle.x = relativeX - GridMagnifier.Rectangle.width * 0.5;
            GridMagnifier.Rectangle.y = relativeY - GridMagnifier.Rectangle.height * 0.5;

            //border area
            let skipMagnifierMoveX = false;
            let skipMagnifierMoveY = false;

            //check borders for magnifier frame
            if (Scaling.isPortrait()) {
                if (GridMagnifier.Rectangle.x + GridMagnifier.Rectangle.width > StageController.Height) {
                    GridMagnifier.Rectangle.x = StageController.Height - GridMagnifier.Rectangle.width;
                } else if (GridMagnifier.Rectangle.x < 0) {
                    GridMagnifier.Rectangle.x = 0;
                    skipMagnifierMoveX = true;
                }

                if (GridMagnifier.Rectangle.y + GridMagnifier.Rectangle.height > StageController.Width) {
                    GridMagnifier.Rectangle.y = StageController.Width - GridMagnifier.Rectangle.height;
                } else if (GridMagnifier.Rectangle.y < 0) {
                    GridMagnifier.Rectangle.y = 0;
                    skipMagnifierMoveY = true;
                }
            } else {
                if (GridMagnifier.Rectangle.x + GridMagnifier.Rectangle.width > StageController.Width) {
                    GridMagnifier.Rectangle.x = StageController.Width - GridMagnifier.Rectangle.width;
                } else if (GridMagnifier.Rectangle.x < 0) {
                    GridMagnifier.Rectangle.x = 0;
                    skipMagnifierMoveX = true;
                }

                if (GridMagnifier.Rectangle.y + GridMagnifier.Rectangle.height > StageController.Height) {
                    GridMagnifier.Rectangle.y = StageController.Height - GridMagnifier.Rectangle.height;
                } else if (GridMagnifier.Rectangle.y < 0) {
                    GridMagnifier.Rectangle.y = 0;
                    skipMagnifierMoveY = true;
                }
            }

            GridMagnifier.Texture.frame = GridMagnifier.Rectangle;
            GridMagnifier.Texture._updateUvs();

            if (!skipMagnifierMoveX) {
                GridMagnifier.MagnifierContainer.x = relativeX - GridMagnifier.Width * 0.5; //center X
            }

            if (!skipMagnifierMoveY) {
                GridMagnifier.MagnifierContainer.y = relativeY - GridMagnifier.Height * 1.2; //1.2 offset Y
            }

            //check magnifier position on screen
            if (Scaling.isPortrait()) {
                if (GridMagnifier.MagnifierContainer.y + GridMagnifier.Height * 0.2 < 0) {
                    GridMagnifier.MagnifierContainer.y = relativeY - GridMagnifier.Height * 0.5; //1.2 offset Y

                    if (GridMagnifier.MagnifierContainer.x - GridMagnifier.Width * 0.5 > 0) {
                        GridMagnifier.MagnifierContainer.x = relativeX - GridMagnifier.Width * 1.2; //center X
                    } else {
                        GridMagnifier.MagnifierContainer.x = relativeX + GridMagnifier.Width * 0.2; //center X
                    }
                }
            } else {
                if (GridMagnifier.MagnifierContainer.y < 0) {
                    GridMagnifier.MagnifierContainer.y = relativeY - GridMagnifier.Height * 0.5; //1.2 offset Y

                    if (GridMagnifier.MagnifierContainer.x - GridMagnifier.Width * 0.5 > 0) {
                        GridMagnifier.MagnifierContainer.x = relativeX - GridMagnifier.Width * 1.2; //center X
                    } else {
                        GridMagnifier.MagnifierContainer.x = relativeX + GridMagnifier.Width * 0.2; //center X
                    }
                }
            }

            //finalize, show magnifier
            document.body.classList.add("magnifier-on");
            GridMagnifier.MagnifierContainer.visible = true;
            StageController.Renderer.render(GridMagnifier.View, GridMagnifier.RenderTexture);
        }
    }

    public static touchEndMagnifier(): void {
        if (GridMagnifier.MagnifierContainer != null) {
            document.body.classList.remove("magnifier-on");
            GridMagnifier.MagnifierContainer.visible = false;
        }
    }

    public static orientationChanged(inPortrait: boolean): void {
        if (GridMagnifier.MagnifierContainer != null) {
            if (inPortrait) {
                GridMagnifier.BaseRenderTexture.resize(StageController.Height, StageController.Width);
            } else {
                GridMagnifier.BaseRenderTexture.resize(StageController.Width, StageController.Height);
            }

            GridMagnifier.Rectangle.width = GridMagnifier.Width * 0.5;
            GridMagnifier.Rectangle.height = GridMagnifier.Height * 0.5;
        }
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/GameComponents/GridMagnifier.ts
 **/